import { APP_INITIALIZER, EnvironmentProviders, ErrorHandler, makeEnvironmentProviders } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { MOBILE_GATEWAY_URL } from "./auth/mobile-auth.config";
import { provideMobileAuthService } from "./auth/mobile-auth.provider";
import { MobileSessionService } from "./auth/mobile-session.service";
import { provideMobileCacheStore } from "./cache/mobile-cache.provider";
import { MobileAuthInterceptor } from "./http/mobile-auth.interceptor";
import { MobileLanguageInterceptor } from "./http/mobile-language.interceptor";
import { provideMobileTokenStorage } from "./http/token-storage.provider";
import { MobileSafeAreaService } from "./platform/mobile-safe-area.service";
import { MobileGlobalErrorHandler } from "./shell/mobile-global-error-handler";

export interface MobileSkeletonConfig {
  gatewayUrl: string;
}

export function provideMobileSkeleton(config: MobileSkeletonConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: MOBILE_GATEWAY_URL, useValue: config.gatewayUrl },
    ...provideMobileTokenStorage(),
    ...provideMobileCacheStore(),
    ...provideMobileAuthService(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MobileAuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MobileLanguageInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: MobileGlobalErrorHandler,
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (sessionService: MobileSessionService, safeAreaService: MobileSafeAreaService) => {
        return () => {
          safeAreaService.applySafeArea();
          return sessionService.bootstrapSession();
        };
      },
      deps: [MobileSessionService, MobileSafeAreaService],
    },
  ]);
}
